// Providers
import NotificationProvider from "@/components/Common/NotificationProvider";
import { getVersionIcon } from "@/components/Common/VersionIcons";
// Styles
import "@/styles/globals.css";

import type { AppProps } from "next/app";
import Head from "next/head";
import { useRouter } from "next/router";
import { ConfigProvider } from "antd";

const MyApp = ({ Component, pageProps }: AppProps) => {
  const currentVersion = process.env.Version || "stable";
  const icon = getVersionIcon(currentVersion);

  // Self-referencing canonical built from the route, which strips query
  // params (e.g. ?scrollTo=...) so URL variants consolidate to the clean
  // page URL for SEO. Error/utility pages get no canonical.
  const router = useRouter();
  const canonical = ["/404", "/401", "/_error"].includes(router.pathname)
    ? null
    : `https://stedprep.com${router.pathname}`;

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily:
            "SF Pro Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif",
        },
      }}
    >
      <NotificationProvider>
        <Head>
          <link rel="icon" href={icon?.type?.src} />
          <link rel="shortcut icon" href={icon?.type?.src} />
          {canonical && <link rel="canonical" href={canonical} />}
          <title>StedPrep</title>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, maximum-scale=1"
          />
        </Head>
        <Component {...pageProps} />
      </NotificationProvider>
    </ConfigProvider>
  );
};

export default MyApp;
